import PouchDB from 'pouchdb';
import { get } from '../utils/api';
import { upsert } from './common';
import endpoints from '../endpoints';

const DELIVERY_PERIODS = 'XXSDeliveryPeriodsStore';

export const mapByCode = (deliveryPeriods) => {
  const p = [...deliveryPeriods];
  return p.reduce((m, d) => {
    // eslint-disable-next-line no-param-reassign
    m[d.c] = { ...d };

    return m;
  }, {});
};

class ProductDeliveryPeriodStore {
  constructor(name) {
    this.db = new PouchDB(name);
  }

  save = (response, onSuccess) => {
    upsert(this.db, DELIVERY_PERIODS, mapByCode(response.data), onSuccess);
  };

  fetchAndSave = (onSuccess) => get(endpoints.deliveryPeriods.get).then((response) => this.save(response, onSuccess));

  load = (callback) => {
    this.db
      .get(DELIVERY_PERIODS)
      .then((doc) => {
        callback(doc);
      })
      .then(() => {})
      .catch(() => {
        callback();
      });
  };
}

export default ProductDeliveryPeriodStore;
